//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import AnalyticsLogger from "@/../../../common/services/AnalyticsLogger.js";

const ResetMarkersAndTargetsActionHandler = class ResetMarkersAndTargetsActionHandler {
  async handle(action, store) {
    if (!store) {
      return;
    }

    store.state.page.data = action.targets_data;
    if (action.mixpanelEvent) {
      AnalyticsLogger.log(action.mixpanelEvent);
    }
  }
};

export default ResetMarkersAndTargetsActionHandler;
